import React, { useEffect, useState } from 'react'
import TopNavbar from '../../CommonComponent/topNavbar/TopNavbar'
import Sidebar from '../../CommonComponent/sidebar/Sidebar'
import { Button, Card, Col, Form, InputGroup, Row, Table } from 'react-bootstrap';
import * as icons from 'react-bootstrap-icons';
import { DatePicker, Loader } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import { useNavigate } from 'react-router-dom';
import { AuctionRegApi, SportAllMap, SportGetById, TeamGetAll, TournamentAll, TournamentGetById, TournamentGetByIdGet, UploadImage, UserGetId, WinCount } from '../../redux/auth-reducer/auth-service';
import { toast, ToastContainer } from 'react-toastify';
import { Footer } from '../../Footer';
import { ImageUrl } from '../../utils/config/config';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import SortableList, { SortableItem } from 'react-easy-sort';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

export const CreateAuction = () => {
  const [data, setData] = useState();
  const [validated, setValidated] = useState(false);
  const [imageName, setImageName] = useState('');
  const [itemList, setItemList] = useState();
  const [seletedTournament, setSeletedTournament] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [itemSport, setItemSport] = useState([]);
  const [dataImage, setDataImage] = useState();
  const [itemTeam, setItemTeam] = useState();
  const [secondryMarketStatus, setSecondryMarketStatus] = useState("");
  const [teamFkID, setTeamFkID] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const [allXcuttaPercentage, setAllXcuttaPercentage] = useState();
  const [errorMessageXcutta, setErrorMessageXcutta] = useState(false);
  const [userData, setUserData] = useState();
  const [idtournament, setIdtournament] = useState();
  const [winingPlace, setWiningPlace] = useState();
  const [marketStatus, setMarketStatus] = useState(false)
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [dateValid, setDateValid] = useState(true);
  const [teamselectData, setTeamselectData] = useState([])
  /************* */
  const [bracketStatus, setBracketStatus] = useState([]);
  const [winnerCount, setWinnerCount] = useState(0);
  const [winners, setWinners] = useState([]);
  const [tournamentData, setTournamentData] = useState();
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [combinedTeamsArray, setCombinedTeamsArray] = useState([]);
  /************ */
  const [teamReg, setTeamReg] = useState({
    auctionId: 0,
    auctionName: "",
    auctionImage: null,
    tournamentId: 0,
    sportId: 0,
    teamId: 0,
    startDate: "",
    bidTime: 0,
    startingBid: 0,
    bidIncrement: 0,
    xcuttaTake: 0,
    winnerTitle: [],
    winnerPercentage: [],
    createdBy: userData?.id,
    secondaryMarket: true
  })
  const [winningPlaceInptData, setWinningPlaceInptData] = useState([]);
  function sidebarfun() {
    setData(!data)
  }
  useEffect(() => {
    if (isDisabled) {
      setIsDisabled(true);

    }
  }, [isDisabled]);

  useEffect(() => {
    if (isButtonDisabled) {
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
    }
  }, [isButtonDisabled]);

  var SportIdSelect = []
  itemSport?.map((value) => {
    if (value?.sportId == seletedTournament) {
      return SportIdSelect.push(value?.sportId);
    }
  })

  const blockInvalidChar = (e) =>
    [
      "+",
      "-",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ].includes(e.key) && e.preventDefault();

  useEffect(() => {
    async function UserGet() {
      await UserGetId().then((res) => {
        setUserData(res);
      })
    }
    UserGet();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!teamReg?.startDate) {
      setDateValid(false);
    } else {
      setDateValid(true);
    }

    if (teamReg.startDate && teamReg.startDate < new Date()) {
      toast.error('Your selected start date and time has already expired. Please select a different time.');
    } else {

      setIsButtonDisabled(true);
      setValidated(true);


      let totalPer = winningPlaceInptData?.reduce((acc, item) => {
 
        acc += Number(item.winnerPercentage);
     
        return acc; // return the acc value
      }, 0);


      totalPer += Number(teamReg?.xcuttaTake);

      // let winnerPercentage = [];

      // winningPlaceInptData.forEach((item) => {
      //   winnerPercentage.push(Number(item.winnerPercentage));
      // });

      let winnerPercentage = winners.map(item => Number(item.winnerPercentage));
      // let winnertitle = winners.reduce((acc, item) => {
      //   item.input.forEach((elem) => {
      //     acc.push(elem.name);
      //   });
      //   return acc;
      // }, []);
      let winnertitle = winners.map(winner => winner.name);



      // totalPer += Number(teamReg?.xcuttaTake)

      if (teamReg?.xcuttaTake.length > 0) {
        setErrorMessageXcutta(false);
      }
      else {
        setErrorMessageXcutta(true);
      }

      // if (teamReg?.winnerCount) {

      //   if (totalPer == 100) {

      //   } else {

      //     return setErrorMessage(true);
      //   }

      // }
      // const totalPer = winningPlaceInptData.reduce((acc, item) => {
      //   item.input.forEach((elem) => {
      //     acc += Number(elem.winnerPercentage) || 0;
      //   });
      //   return acc;
      // }, 0);

      // totalPer += Number(teamReg?.xcuttaTake);

      // if (totalPer !== 100) {
      //   return setErrorMessage(true);
      // }

      const isUser = JSON.parse(localStorage.getItem('isUser'));
      const userId = isUser?.userId;

      // const RegisterData = [
      //   {
      //     "crudOperationId": true,
      //     "auctionName": teamReg?.auctionName,
      //     "auctionImage": dataImage || "",
      //     "tournamentId": teamReg?.tournamentId,
      //     "sportId": SportIdSelect.toString(),
      //     "teamId": teamFkID,
      //     "startDate": teamReg?.startDate,
      //     "startingBid": teamReg?.startingBid,
      //     "bidIncrement": teamReg?.bidIncrement,
      //     "xcuttaTake": teamReg?.xcuttaTake,
      //     "winnerCount": teamReg?.winnerCount,
      //     "bidTime": teamReg?.bidTime,
      //     "winnerTitle": winnertitle,
      //     "winnerPercentage": winnerPercentage,
      //     "createdBy": userId,
      //     "secondaryMarket": marketStatus,
      //     "isPrivate": secondryMarketStatus || false
      //   }
      // ];
 

      const newRegistration = combinedTeamsArray?.map((item)=>item?.id);



      const RegisterData = [
        {
       
          "crudOperationId": true,
          "auctionId":0,
          "auctionName": teamReg?.auctionName,
          "auctionImage": dataImage || null,
          "tournamentId": teamReg?.tournamentId,
          "sportId": SportIdSelect.toString(),
          "teamId": newRegistration,
          "startDate": teamReg?.startDate,
          "startingBid": teamReg?.startingBid,
          "bidIncrement": teamReg?.bidIncrement,
          "xcuttaTake": teamReg?.xcuttaTake,
          "winnerCount": winnerCount,
          "bidTime": teamReg?.bidTime,
          "winnerTitle": winnertitle,
          "winnerPercentage": winnerPercentage,
          // "createdBy": userId,
          "secondaryMarket": marketStatus,
          "isPrivate": secondryMarketStatus || false
        }
      ];

      if (teamReg.auctionName == "" || teamReg.startDate == "" || teamReg.startingBid == 0 || teamReg.bidIncrement == 0 || teamReg.xcutt == '' || teamReg.bidTime == 0 || teamReg.winnerTitle == [] || teamReg.winnerPercentage == []) {
        toast.error("field is required");
      } else {
        await AuctionRegApi(RegisterData).then((res) => {

          if (res?.data.status===true) {
            toast.success(res?.data?.message);
            setLoading(false);
            navigate('/SuperAdmin/Auction');
            // window.location.reload();

          } else {
            toast.error(res?.data?.message);
          }

        })
      }

    }

  }


  useEffect(() => {

    const TournamentAllFn = async () => {
      await TournamentAll().then((response) => {

        setItemList(response?.data?.data?.dataList);

      })
    }
    TournamentAllFn();

  }, [])

  useEffect(() => {

    const SportAllFn = async () => {
      await SportAllMap().then((response) => {
        setItemSport(response?.data?.data?.dataList);
      })
    }
    SportAllFn();

  }, [])

  useEffect(() => {

    const SportByIDFn = async () => {
      await SportGetById(seletedTournament).then((response) => {
        setBracketStatus(response?.data?.isBracket);

      })
    }
    SportByIDFn();

  }, [seletedTournament])

 


  const handleFileChange = (event) => {
    setSelectedImage(URL.createObjectURL(event.target.files[0]));

    setImageName(event.target.files[0].name)

    const dataList = (event.target.files[0]);

    const imageAPI = async () => {
      const formDataImage = new FormData();
      formDataImage.append('file', dataList);

      await UploadImage(formDataImage).then((res) => {
        if (res?.data?.status) {

          setDataImage(res?.data?.message);

        } else {
          toast.error(res?.message);
        }
      })
    }

    imageAPI()
  };

  const formatDate = (date) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
    const formatted = date.toLocaleString('en-US', options);

    const [month, day, year, time] = formatted.split(/[/,\s]+/);
    return `${month}/${day}/${year} ${time}`;
  };
  const handelDate = async (event) => {

    const utcDate = new Date(event);
    const istDate = new Date(utcDate.getTime());

    const formattedDate = formatDate(istDate);
    
    setTeamReg({
      ...teamReg,
      startDate: event ? moment.utc(event) : "",
    },)
    setDateValid(event ? true : false)
  };

  const handelVisible = (e) => {
    setMarketStatus(true);
    setIsShow(!isShow)

  }
  const navigate = useNavigate();
  const cancelbtn = (e) => {
    navigate(-1)
  }

  var filteredTeams = itemTeam?.filter((listItem) => teamFkID?.includes(listItem?.teamId));
  useEffect(() => {
    if (idtournament) {
      let auctionTeams = tournamentData?.auctionTeamsName?.split(',').map(team => team.trim());
      let auctionTeamsId = tournamentData?.auctionTeams?.split(',').map(team => team.trim());
      var auctionTeamsImageData = tournamentData?.auctionTeamsImage?.split(',').map(team => team.trim());
      const combinedTeams = auctionTeams?.map((teamName, index) => ({
        id: auctionTeamsId[index], // Get the corresponding ID
        name: teamName,
        image: auctionTeamsImageData[index]// Get the team name
      })) || [];

      setCombinedTeamsArray(combinedTeams);
    }
  }, [idtournament, tournamentData]);


  var auctionTeamsImageData = tournamentData?.auctionTeamsImage?.split(',').map(team => team.trim());


  const handleSelectedTurnament = (event) => {

    const [value, array] = event.target.value.split("-");
    const [value1, textContent] = array.split("=")
    setIsDisabled(false)
    setTeamFkID(array.split(",").map((e) => parseInt(e)));

    setSeletedTournament(value);
    setTeamReg({
      ...teamReg,
      tournamentId: parseInt(textContent),
    },)




    setIdtournament(textContent)




  }







  // useEffect to call TournamentGetById when seletedTournament changes
  useEffect(() => {
    if (idtournament) {
      const TournamentIDFn = async () => {
        const response = await TournamentGetByIdGet(idtournament);

        setTournamentData(response);
      };
      TournamentIDFn();
    }
  }, [idtournament]); // Dependency array with seletedTournament




  // useEffect(() => {

  //   if (idtournament) {
  //     var auctionTeams = tournamentData?.auctionTeamsName?.split(',').map(team => team.trim());
  //     let datateam= auctionTeams?.length;
  //     const AuctionWiningPlace = async () => {
  //       await WinCount(datateam).then((response) => {
  //         setWiningPlace(response?.data)
  //       })
  //     }
  //     AuctionWiningPlace();
  //   }
  // }, [idtournament]);

  useEffect(() => {
    if (idtournament) {
      const auctionTeams = tournamentData?.auctionTeamsName?.split(',').map(team => team.trim());
      const datateam = auctionTeams?.length;

      const AuctionWiningPlace = async () => {
        try {
          const response = await WinCount(datateam);
          setWiningPlace(response?.data);
        } catch (error) {
          console.error("Error fetching winning place:", error);
        }
      };

      if (datateam > 0) {
        AuctionWiningPlace();
      }
    }
  }, [idtournament, tournamentData]);


  useEffect(() => {
    const TeamAllFn = async () => {
      await TeamGetAll().then((response) => {
        setItemTeam(response?.data?.data?.dataList);
      })
    }
    TeamAllFn();

  }, [])


  const handelAuction = (e) => {

    setTeamReg({
      ...teamReg,
      [e.target.name]: e.target.value,
    },)
    setErrorMessage(false)
    // setErrorMessageXcutta(false);
  }

  const handelAuctionTake = (e) => {
    setAllXcuttaPercentage(100 - e.target.value)
    const value = e.target.value;
    if (value >= 0) {
      setInputValue(value);
    }
    setTeamReg({
      ...teamReg,
      [e.target.name]: e.target.value,
    },)
    setErrorMessage(false)
    setErrorMessageXcutta(false);
  }

  const handelAuctionWinner = (e) => {
    const { name, value } = e.target;
    let newTeamReg = { ...teamReg };
    if (name === "winnerPercentage") {
      const index = parseInt(e.target.dataset.index, 10);
      newTeamReg.winnerPercentage[index] = Number(value);
    } else {
      newTeamReg[name] = value;
    }

    setTeamReg(newTeamReg);
    setErrorMessage(false);
  }


  const handelCount = (e) => {
    const count = parseInt(e.target.value, 10);
    setWinnerCount(count);

    const newWinners = Array.from({ length: count }, (_, index) => ({
      name: `Place ${index + 1}`,
      winnerPercentage: ''
    }));
    setWinners(newWinners);

  
    setWinningPlaceInptData(data);
  };

  const handelSecondry = (e) => {
    const selectedValue = e.target.value;
    setTeamReg({
      ...teamReg,
      secondaryMarket: selectedValue,
    });

    if (selectedValue === 'Public') {
      setSecondryMarketStatus(true);
    } else if (selectedValue === 'Private') {
      setSecondryMarketStatus(false);
    }
  };

  const [fnDisabled, setFnDisabled] = useState(true);




  const handleWinningPlaceChange = (event, levelIndex, j) => {

    const { name, value } = event.target;
    const updatedWinners = [...winners];
    updatedWinners[levelIndex][name] = value;
    setWinners(updatedWinners);
  }
  const isUser = JSON.parse(localStorage.getItem('isUser'));




  const onSortEnd = (result) => {
    if (!result.destination) return; // Dropped outside the list
    const newCombinedTeamsArray = Array.from(combinedTeamsArray);
    const [movedItem] = newCombinedTeamsArray.splice(result.source.index, 1);
    newCombinedTeamsArray.splice(result.destination.index, 0, movedItem);
    setCombinedTeamsArray(newCombinedTeamsArray);
  };



  return (
    <>


      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group " >
        <Sidebar data={data} />
        <div className={data ? "dashboard-content full-contnet" : "dashboard-content "}>
          <Row>
            <Col md={6}><h1 className="heading-dash">Create New Auction</h1>
            </Col>
            <Col md={12}>
              <Card className='p-3 mt-3'>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                
                  <Row>
                    <Col md={4} className='text-center'>
                      <Form.Label className='mt-5'>Upload  a Logo</Form.Label>
                      <div className='group-section-auction'>
                        <Form.Label for="browse" name="auctionImage" className='image-chosse' onChange={handleFileChange}>
                          <icons.CameraFill className='icon-camera' />
                          <input id="browse" type="file" accept=".jpg,.jpeg,.png" hidden required />
                        </Form.Label>
                        {dataImage ? <img src={ImageUrl + dataImage} alt="Selected" width={100} className='image-auction-create' /> : ""}
                      </div>
                      <p className='mt-2 image-upload-mess'>(jpeg, jpg, png and size upto 2 mb)<span className='text-danger'>*</span></p>
                      {loading && <Loader />}

                      <Form.Control.Feedback type="invalid">
                        Please select a Contest.
                      </Form.Control.Feedback>
                    </Col>
                    <Col md={6} className='border-custom'>
                      <Form.Group className="text-left">
                        <Form.Label>Select Contest</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Select name="tournamentId" className='select-option tournament' required as="select" onChange={handleSelectedTurnament}>
                            <option>Select Contest</option>
                            {
                              itemList?.map((item) => {
                                if (isUser?.userId === item?.createdBy) {
                                  return (
                                    <option key={item?.tournamentId} value={`${item?.sportId} - ${item.teamId} = ${item?.tournamentId}`}>
                                      {item?.tournamentName}
                                    </option>
                                  );
                                }
                                return null;
                              })
                            }

                          </Form.Select >
                          <Form.Control.Feedback type="invalid">
                            Please select a Contest.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>

                      {
                        seletedTournament ? (
                          <div>
                            <p>{bracketStatus ? <h5 className='text-success mt-3'>Bracket created</h5> : <h5 className='text-danger mt-3'>No Bracket</h5>}</p>

                          </div>
                        ) : (
                          ""
                        )
                      }

                      <p className={`${seletedTournament ? "mt-3 label" : ""}`}> {
                        `${seletedTournament ? "Sport Name" : ""}`
                      }  </p>

                      <p className={`${seletedTournament ? "input-game" : ""}`}>{itemSport?.map((value) => value?.sportId == seletedTournament && value?.sportName)}</p>

                      {seletedTournament ?


                      <> <p className='mt-3 label'> <span className='text-danger'>*</span> </p>Positions of auction teams can be changed by drag & drop.
                       
                        <DragDropContext onDragEnd={onSortEnd}>
                          <Droppable droppableId="droppable">
                            {(provided) => (
                              <Table className='table-team border mt-3'  ref={provided.innerRef} {...provided.droppableProps}>
                                <thead>
                                  <tr style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                  <th style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>S.No</th>
                                    {bracketStatus ? <th>Team</th> : <th>Player</th>}
                                    <th style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center'}}>Name</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {combinedTeamsArray.map((team, index) => (
                                   team.name!=="The Field (All Remaining Teams)"? 
                                   <Draggable key={team.id} draggableId={team.id} index={index}>
                                   {
                                   (provided) => (
                                     <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                       <td style={{ textAlign: 'center' }}>  {index+1} </td>
                                       <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                        {
                                          team?.image===""?<img src="../image/team-icon.png" width={50}></img>:<img
                                          src={ImageUrl+team?.image}
                                          alt={`Image for ${team.name}`}
                                          style={{ width: '50px', height: '50px' }}
                                        />
                                        }
                                        
                                         
                                       </td>
                                       <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                         {team.name}
                                       </td>
                                     </tr>
                                   )
                                   }
                                 </Draggable>: <tr >
                                       <td style={{ textAlign: 'center' }}>
                                        {index+1}</td>
                                       <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                         <img
                                           src={auctionTeamsImageData[index] ? `${ImageUrl}${auctionTeamsImageData[index]}` : '../image/team-icon.png'}
                                           alt={`Image for ${team.name}`}
                                           style={{ width: '50px', height: '50px' }}
                                         />
                                       </td>
                                       <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                                         {team.name} - <span className='text-success fs-6 fw-bold'>Fixed Position</span>
                                       </td>
                                     </tr>
                                  ))}
                                </tbody>
                              </Table>
                            )}
                          </Droppable>
                        </DragDropContext>
                        </>
                        : ""}

                      <Row>


                        <Form.Group as={Col} md={6} controlId="validationCustom02">
                          <Form.Label>Auction Name</Form.Label>
                          <Form.Control name="auctionName" maxLength={50} onChange={handelAuction} className='select-option tournament' required type="text" placeholder="Enter your Auction Name" />
                          <Form.Control.Feedback type="invalid">
                            Please enter Auction Name.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} md={6}>
                          <Form.Label>Auction Start Date</Form.Label>
                          <DatePicker format="MM/dd/yyyy hh:mm:ss aa" showMeridian placeholder="Start Date"
                            disabledDate={(date) => date < new Date().setHours(0, 0, 0, 0)}
                            name="startDate" className=' Auction-Date'
                            onChange={handelDate} required />

                          <Form.Control.Feedback type="invalid" style={{ display: dateValid ? 'none' : 'block' }}>
                            Please select the start date and time.
                          </Form.Control.Feedback>

                        </Form.Group>
                        <Form.Group as={Col} md={6}>
                          <Form.Label className='mt-3'>Bid Time Limit</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Select name="bidTime" onChange={handelAuction} className='select-option tournament' required as="select">
                              <option value="" >Select Time Limit</option>
                              <option value={0.5} >0.5 minute</option>
                              <option value={1} >1 minute</option>
                              <option value={2} >2 minutes</option>
                              <option value={3}>3 minutes</option>
                              <option value={4} >4 minutes</option>
                              <option value={5} >5 minutes</option>
                              <option value={6} >6 minutes</option>
                              <option value={7} >7 minutes</option>
                              <option value={8} >8 minutes</option>
                              <option value={9} >9 minutes</option>
                              <option value={10} >10 minutes</option>
                            </Form.Select >
                            <Form.Control.Feedback type="invalid">
                              Please add Bid Time Limit.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>

                        <Form.Group as={Col} md={6}>
                          <Form.Label className='mt-3'>Manager Hold ( % )</Form.Label>
                          <input name="xcuttaTake" value={inputValue} onChange={handelAuctionTake} className='select-option tournament xcuttaTakeinput' type="number" placeholder="Enter your cut" onKeyDown={blockInvalidChar} />
                          {
                            errorMessageXcutta ? <p className='err-message'>Please enter Manager Hold.</p> : ""
                          }

                        </Form.Group>

                        <Form.Group as={Col} md="6 mt-3">

                          <Form.Label>Starting Bid</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Control
                              type="number"
                              name="startingBid"
                              onChange={handelAuction}
                              placeholder="Enter your Starting Bid"
                              aria-describedby="inputGroupPrepend"
                              required
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a starting bid.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>

                        <Form.Group as={Col} md="6 mt-3">

                          <Form.Label>Minimum Bid Increment</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Control
                              type="number"
                              name="bidIncrement"
                              onChange={handelAuction}
                              placeholder="Enter your Bid Increment"
                              aria-describedby="inputGroupPrepend"
                              required
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a  bid increment.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Row>

                      {
                        allXcuttaPercentage === 0 || allXcuttaPercentage < 0
                          ? ''
                          : <>
                            <p className='winner-distribution'>Winner Prize Distribution {allXcuttaPercentage} %</p>
                            <Form.Label>Total Winners</Form.Label>

                            <Form.Select
                              name="winnerCount"
                              disabled={isDisabled}
                              onChange={handelCount}
                              className='select-option tournament'
                              required
                              as="select"
                            >
                              <option value="">Select Winner Count</option>
                               {combinedTeamsArray?.length > 0 && (
                                [...Array(combinedTeamsArray?.length).keys()].map((num) => (
                                  <option key={num + 1} value={num + 1}>
                                    {num + 1}
                                  </option>
                                ))
                              )}
                            </Form.Select>
                          </>
                      }

                      {winnerCount > 0 && (
                        <div className='winner-percentage'>
                          <Row>
                            {Array.from({ length: winnerCount }).map((_, levelIndex, j) => (
                              <Col md={12} key={levelIndex}>
                                <div>
                                  <input
                                    type='text'
                                    className='input-editable'
                                    name={`winnerName-${levelIndex}`}
                                    placeholder={`Place ${levelIndex + 1}`}
                                    value={winners[levelIndex]?.name}

                                    // onChange={(e) => {
                                    //   handleWinningPlaceChange(levelIndex, j)
                                    // }}
                                    disabled={fnDisabled}
                                  />

                                  

                                  <input
                                    name={`winnerPercentage`}
                                    className='select-option tournament xcuttaTakeinput mb-2'
                                    placeholder='Enter Percentage'
                                    type="number"
                                    value={winners[levelIndex]?.winnerPercentage}
                                    onChange={(e) => {
                                      handleWinningPlaceChange(e, levelIndex, j)

                                    }}
                                  />
                                </div>
                              </Col>
                            ))}
                          </Row>

                          {errorMessage && (
                            <p className='err-message'>
                              Please ensure that the total distribution among the winners should be equal to {allXcuttaPercentage}%
                            </p>
                          )}
                        </div>
                      )}

                      <label for="market" className='input-check-group mt-3'  >
                        <input type="checkbox" id="market" name="market" className='inputCheck' onClick={handelVisible} />Secondary Market</label>
                      {
                        isShow ? <Form.Group as={Col} className='mt-3' controlId="validationCustom02">
                          <Form.Label>Types of Secondary Market</Form.Label>
                          <InputGroup hasValidation>
                            <Form.Select
                              name="secondaryMarket"
                              onChange={handelSecondry}
                              className='select-option tournament' >
                              <option value="">Select an option</option>
                              <option value={'Public'}>Public</option>
                              <option value={'Private'}>Private</option>
                            </Form.Select>
                          </InputGroup>
                        </Form.Group> : ""
                      }
                      <button type="button" className='cancel-btn mt-3' onClick={cancelbtn} >Cancel</button>
                      <Button type="submit" disabled={isButtonDisabled} className='update-btn-prof '>Save</Button>
                    </Col>
                    <Col md={2}></Col>
                  </Row>
                </Form>
              </Card>
            </Col>

          </Row>

        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  )
}


